const ranges = {
  advancedPurchaseRange: ['0-1', '2-4', '4-7', '8-14', '15-21', '22-30', '31-60', '61+'],
  priceRange: ['0-249', '250-499', '500-749', '750-999', '1000-1499', '1500-1999', '2000-2999', '3000+'],
  itineraryPlacementRange: [
    '1',
    '2',
    '3',
    '4',
    '5-6',
    '7-8',
    '9-10',
    '11-15',
    '16-20',
    '21-25',
    '26-30',
    '31-40',
    '41-50',
    '51-75',
    '76-100',
    '101-200',
    '201+',
  ],
  pageViewRange: ['1', '2', '3', '4', '5-6', '7-8', '9-10', '11-15', '16-20', '21+'],
}

export { ranges }
